import React from 'react';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { NotificationImportant } from '@insurancemenu/imenu-components-lib/dist/icons';
import StepHeader from 'components/common/headers/StepHeader';
import { observer } from 'mobx-react-lite';
import { ICensusModule } from 'store/modules/census/iCensusModule';
import ICensusUploadPageStore, { CensusUploadDomainParams } from 'store/modules/census/iCensusUploadPageStore';
import { InValidCensusSectionStyled } from './styles';
import { StepSubtitleStyled } from '../StepSubtitleStyled';
import { INVALID_CENSUS_SECTION_TEST_ID, REVIEW_ERRORS_BTN_TEST_ID } from '../constants';

interface Props {
  pageStore: ICensusUploadPageStore<CensusUploadDomainParams, ICensusModule<CensusUploadDomainParams>>;
}

const ExistingInvalidCensusSection: React.FC<Props> = observer(
  ({ pageStore: { censusModule, onCompleteRedirect } }) => {
    return (
      <InValidCensusSectionStyled
        $disabled={!censusModule.noUploadedFiles}
        data-test-id={INVALID_CENSUS_SECTION_TEST_ID}
      >
        <StepHeader
          stepIcon={
            <NotificationImportant
              width="3.2rem"
              color={!censusModule.noUploadedFiles ? colors.neutral[300] : colors.orange[500]}
            />
          }
          stepTitle="Fix Census Errors"
          stepSubtitle={
            <StepSubtitleStyled>{`We’ve identified some errors with the Census you just uploaded with ${censusModule.existingCensusInfo?.familyAmount} subscribers. You can review the errors by selecting the button below.`}</StepSubtitleStyled>
          }
        />
        <Button
          onClick={onCompleteRedirect}
          size="large"
          color="custom"
          customColor={colors.orange[500]}
          disabled={!censusModule.noUploadedFiles}
          data-test-id={REVIEW_ERRORS_BTN_TEST_ID}
        >
          Review errors
        </Button>
      </InValidCensusSectionStyled>
    );
  },
);

export default ExistingInvalidCensusSection;
